import { render, staticRenderFns } from "./FrameCheckDossier.vue?vue&type=template&id=368c826f&scoped=true&"
import script from "./FrameCheckDossier.vue?vue&type=script&lang=js&"
export * from "./FrameCheckDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c826f",
  null
  
)

export default component.exports